<template>
  <transition name="dialogfade">
    <k-dialog
      v-if="open"
      :title="title"
      class="error__dialog"
      @close="$emit('close')"
      @overlay-click="$emit('close')"
    >
      <p class="error-dialog__msg">{{ msg }}</p>
    </k-dialog>
  </transition>
</template>

<script>
import { Dialog } from "@progress/kendo-vue-dialogs";

export default {
  name: "ErrorDialog",
  components: {
    "k-dialog": Dialog
  },
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: "Error" },
    msg: { type: String, default: "" }
  }
};
</script>

<style src="@/assets/css/commandcenter/commandcenter.css"></style>
